module.exports = __webpack_public_path__ + "img/logo-sexy-baccarat.4ec81935.png";